import Vuex from 'vuex';
import { createHelpers } from 'vuex-map-fields';

Vue.use(Vuex);

const { getFieldsPerfil, updateFieldsPerfil } = createHelpers({
  getterType: 'getFieldsPerfil',
  mutationType: 'updateFieldsPerfil',
});

export default {
  namespaced: true,
  state: {
    empresa: {},
    comercial: {
      fecha_fundacion: '',
    },
    imagenes: [],
    tecnico: {
      num_empleados: '1a3',
      uniforme: 'Sólo playera',
      servicios_urgentes: 'No',
    },
    tipo_mudanza: [],
    tipo_equipo: [],
    tipo_servicios: [],
    tipo_proteccion: [],
    vehiculos: [],
    documentos: [],
    tabIndex: 1,
  },
  getters: {
    getFieldsPerfil,
  },
  mutations: {
    updateFieldsPerfil,
    quitar_imagen_galeria(state: { imagenes: unknown[] }, index: number) {
      state.imagenes.splice(index, 1);
    },
    push_img_galeria(state: { imagenes: unknown[] }, payload: unknown) {
      state.imagenes.push(payload);
    },
  },
};
